import { Component, HostListener } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from './services/auth.service';
import { UnsavedChangesService } from './services/unsavedChanges.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public constructor(
    private authService: AuthService,
    private unsavedChangesService: UnsavedChangesService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    ) {

    this.authService.configure();
    iconRegistry.addSvgIconSet(
    sanitizer.bypassSecurityTrustResourceUrl('assets/icons.svg'));
  }
  
  @HostListener('window:beforeunload', ['$event']) public unloadHandler(event: Event): void {
    if (this.unsavedChangesService.hasChanges()){
      event.returnValue = false;
    }
  }
}
